<template>
    <section class="services-overview">
        <div class="container">
        <h2 class="title">{{ $t('servicesOverviewTitle') }}</h2>
        <p>{{ $t('servicesSubtitle') }}</p>
        <div class="services-wrapper">
            <router-link to="/services" class="service">
                <img src="@/assets/images/icons/availability-svgrepo-com.svg"/>
                <div class="description">
                    <h5>{{ $t('serviceListItemTitle_1') }}</h5>
                    <p>{{ $t('serviceListItemDescription_1') }}</p>
                </div>
            </router-link>
            <router-link to="/services" class="service">
                <img src="@/assets/images/icons/mobile-app-svgrepo-com.svg"/>
                <div class="description">
                    <h5>{{ $t('serviceListItemTitle_2') }}</h5>
                    <p>{{ $t('serviceListItemDescription_2') }}</p>
                </div>
            </router-link>
            <router-link to="/services" class="service">
                <img src="@/assets/images/icons/host-record-svgrepo-com.svg"/>
                <div class="description">
                    <h5>{{ $t('serviceListItemTitle_3') }}</h5>
                    <p>{{ $t('serviceListItemDescription_3') }}</p>
                </div>
            </router-link>
            <router-link to="/services" class="service">
                <img src="@/assets/images/icons/7x24h-svgrepo-com.svg"/>
                <div class="description">
                    <h5>{{ $t('serviceListItemTitle_4') }}</h5>
                    <p>{{ $t('serviceListItemDescription_4') }}</p>
                </div>
            </router-link>
            <router-link to="/services" class="service">
                <img src="@/assets/images/icons/multiple-defenses-svgrepo-com.svg"/>
                <div class="description">
                    <h5>{{ $t('serviceListItemTitle_5') }}</h5>
                    <p>{{ $t('serviceListItemDescription_5') }}</p>
                </div>
            </router-link>
            <router-link to="/services" class="service">
                <img src="@/assets/images/icons/system-settings-svgrepo-com.svg"/>
                <div class="description">
                    <h5>{{ $t('serviceListItemTitle_6') }}</h5>
                    <p>{{ $t('serviceListItemDescription_6') }}</p>
                </div>
            </router-link>
        </div>
        <router-link class="primary-button" to="/services">{{ $t('servicesOverviewCTA') }}</router-link>
        </div>
    </section>
</template>

<script>
export default {
  name: 'ServicesOverview'
}
</script>

<style scoped>
.services-wrapper {
    display: grid;
    grid-template-columns:repeat(auto-fill,minmax(400px,1fr));
    gap: 60px;
    margin-bottom: 60px;
}
.services-wrapper h5 {
    font-family: var(--secondary-font);
    font-size: 24px;
    margin-bottom: 30px;
}
.services-wrapper p {
    margin-bottom: 0;
    color: var(--text-color);
}
.services-wrapper .service img {
    width: 60px;
    height: auto;
}
.services-wrapper .service h5 {
    margin: 0;
}
@media(max-width: 768px) {
    .services-wrapper {
        grid-template-columns: 1fr;
    }
}

</style>
